import { useQueryString } from '#hooks/useQueryString';
import { useGetRecordsV2 } from '#pages/DashboardChartForm/api';
import { match } from 'ts-pattern';
import { NoFeedback } from './NoFeedback';

export const ExerciseIntensity = () => {
  const list = [
    { text: '너무 쉬움' },
    { text: '쉬움' },
    { text: '보통' },
    { text: '어려움' },
    { text: '너무 어려움' }
  ];

  const [registedLectureId] = useQueryString(['registered-lecture-id']);

  const { data } = useGetRecordsV2(registedLectureId);

  if (!data) return <div></div>;

  return (
    <div className="w-full">
      <div className="text-[#938f9e] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
        운동 강도
      </div>
      <div className="w-full h-8"></div>
      {match(data.registeredLectureRecord.exerciseIntensity)
        .with(null, () => <NoFeedback />)
        .otherwise(exerciseIntensity => (
          <div className="w-full flex gap-8">
            {list.map((item, index) => (
              <ExerciseIntensityItem
                key={item.text}
                index={index}
                isSelected={index + 1 === exerciseIntensity}
                text={item.text}
              />
            ))}
          </div>
        ))}
    </div>
  );
};

const ExerciseIntensityItem = ({
  isSelected,
  index,
  text
}: {
  isSelected: boolean;
  index: number;
  text: string;
}) => {
  return (
    <div
      style={{
        backgroundColor: isSelected ? '#2e2a3a' : '#746f7e',
        borderColor: isSelected ? '#7750e9' : 'transparent'
      }}
      className="flex-1 h-[71px] py-4  rounded-lg border-1 border-solid flex-col justify-center items-center gap-1 inline-flex"
    >
      <div className="text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
        {index + 1}
      </div>
      <div
        style={{
          color: isSelected ? '#746f7e' : '#938f9e'
        }}
        className="text-[10px] font-normal font-['Pretendard Variable'] leading-[13px] tracking-tight"
      >
        {text}
      </div>
    </div>
  );
};
